// api.js
let apiHost;
if(!apiHost){
	apiHost = 'https://api.tozostore.com/api/v1/';
	// apiHost = 'https://api.tozo.tech/api/v1/'
}

//已实现的组件语言包切换 1英语  5西班牙语 9日语
//后端定义的语言包 1英语  2暂无 3简体 4繁体 5西班牙语 6德语 7法语 8意大利语 9日语 10韩语 11波兰 12葡萄牙 13俄语 14土耳其语 15乌克兰语
let lang_list;
if(!lang_list){
	lang_list = [
		{
			lang: 'en',
			lang_id: 1, //英文
		},
		{
			lang: 'zh_cn',
			lang_id: 3, //中文简体
		},
		{
			lang: 'zh_cc',
			lang_id: 4, //中文繁体
		},
		{
			lang: 'es',
			lang_id: 5, //西班牙语
		},
		{
			lang: 'de',
			lang_id: 6, //德语
		},
		{
			lang: 'fr',
			lang_id: 7, //法语
		},
		{
			lang: 'it',
			lang_id: 8, //意大利语
		},
		{
			lang: 'ja',
			lang_id: 9, //日语
		},
		{
			lang: 'ko',
			lang_id: 10, //韩语
		},
		{
			lang: 'pl',
			lang_id: 11, //波兰
		},
		{
			lang: 'pt',
			lang_id: 12, //葡萄牙
		},
		{
			lang: 'ru',
			lang_id: 13, //俄语
		},
		{
			lang: 'tr',
			lang_id: 14, //土耳其语
		},
		{
			lang: 'uk',
			lang_id: 15, //乌克兰语
		}
	]
}

function get_lang_id(lang){
	let lang_id;
	// 使用 find 查找匹配项
	if(lang && lang_list && lang_list.length != 0){
		let matchedLang = lang_list.find(item => item.lang === lang);
		if (matchedLang) {
			lang_id = matchedLang.lang_id; // 赋值 lang_id
		}
	}
	return lang_id ? lang_id : 1
}

/**
 * 发送 API 请求
 * @param {string} endpoint - API 端点
 * @param {Object} data - 要发送的数据
 * @returns {Promise} - 返回一个 Promise 对象
 */
function callApi(endpoint, method, data ) {
	if(data && data.lang_id){
		data.lang_id = get_lang_id(data.lang_id)
	}
  	return fetch(apiHost + endpoint, {
		method: method,
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
  	})
  	
	.then(response => response.json())
    .then(res => {
		console.log(res)
		if (res.code === 1) {
			return res
	  	}else{
			return Promise.reject(res)
		}
  	})
  	.catch(error => {
		console.log(error)
    	console.error('API Error:', error);
		return Promise.reject(error)
    	// throw error;
  	});
}
